import templateUrl from 'servicestack/automations/template-view.htm';
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
//import config from 'servicestack/tags/_config'
//import labels from 'servicestack/tags/_labels'
import modals from 'webmodals/modals'

class TemplateViewController {
    constructor(options) {
        const $ctrl = this;
		basicController($ctrl);
		$ctrl.recipe = options.recipe;
		$ctrl.automation = options.automation || {};
		$ctrl.request = {};
		if (options.automation) $ctrl.request = options.automation;
		$ctrl.bus = new ServiceBus();
		$ctrl.bus.send('GetTemplates.json').then(function (response) {
			$ctrl.templates = response.data;
			$ctrl.automation.ingredients.forEach(function (ingredient) {
				if (ingredient.type === "template") {
					$ctrl.templates.forEach(function (template) {
						if (template.name === ingredient.value) {
							$ctrl.template = template;
						}
					});
				}
			});
		});

		$ctrl.title = options.title || 'Template View';
        console.debug($ctrl);
	}

}

const TemplateView = {
    open(options) {
        return modals.open(Object.assign({
			size: 'xl automation-prompt',
			preventAutoHeight: true,
            templateUrl,
            resolve: {
                options: () => options
            },
            bindToController: true,
            controller: TemplateViewController,
            controllerAs: '$ctrl'
        }, (options || {}).modal)).result;
    }
};

export default TemplateView;